import React, { FC } from 'react'

import { Grid, Typography, useTheme, Box, useMediaQuery } from '@mui/material'
import { CircularProgressbar } from 'react-circular-progressbar'

import { CircularBarProps } from '../types'

export const CircularBarSection: FC<CircularBarProps> = ({
  title,
  positiveVal,
  negativeVal,
  positiveLabel,
  negativeLabel,
  positiveTextComponent,
  negativeTextComponent,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const positiveMagnitude = Math.abs(Number(positiveVal) || 0)
  const negativeMagnitude = Math.abs(Number(negativeVal) || 0)
  const percentage = (positiveMagnitude / (positiveMagnitude + negativeMagnitude || 1)) * 100

  return (
    <Grid container direction="column" spacing={isMobile ? 2 : 3}>
      {/* Title */}
      <Grid item>
        <Typography variant={isMobile ? 'subtitle1' : 'h6'} fontWeight="bold">
          {title}
        </Typography>
      </Grid>

      {/* Main content */}
      <Grid
        item
        container
        direction={{ xs: 'column', md: 'row' }}
        alignItems="center"
        justifyContent="space-between"
        spacing={{ xs: 2, sm: 3 }}
      >
        {/* Circular chart */}
        <Grid
          item
          xs={12}
          sm={6}
          display="flex"
          justifyContent="center"
          alignItems="center"
          mb={isMobile ? 2 : 0}
        >
          <Box
            width={isMobile ? theme.spacing(14) : theme.spacing(16)}
            height={isMobile ? theme.spacing(14) : theme.spacing(16)}
          >
            <CircularProgressbar
              value={percentage}
              strokeWidth={isMobile ? 10 : 13}
              styles={{
                path: {
                  stroke: theme.palette.green[400],
                  strokeLinecap: 'butt',
                },
                trail: {
                  stroke: theme.palette.red[400],
                  strokeLinecap: 'butt',
                },
              }}
            />
          </Box>
        </Grid>

        {/* Text info */}
        <Grid
          item
          xs={12}
          sm={6}
          container
          direction="column"
          justifyContent="space-between"
          gap={isMobile ? 2 : 0}
          pb={isMobile ? 2 : 0}
        >
          <Grid item>
            <Typography fontSize={12} fontWeight="bold" color={theme.palette.grey[700]}>
              {positiveLabel}
            </Typography>
            {positiveTextComponent || (
              <Typography variant={isMobile ? 'h5' : 'h4'}>{positiveVal}</Typography>
            )}
          </Grid>
          <Grid item>
            <Typography fontSize={12} fontWeight="bold" color={theme.palette.grey[700]}>
              {negativeLabel}
            </Typography>
            {negativeTextComponent || (
              <Typography variant={isMobile ? 'h5' : 'h4'}>{negativeVal}</Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
